import { FC, ReactElement, ReactNode } from 'react';

interface IShieldProps {
  children: ReactNode;
  width?: string;
  className?: string;
}

const IconWrapper: FC<IShieldProps> = ({ width = '20px', className, children }) => {
  return (
    <div className={className} style={{ minWidth: width, maxWidth: width }}>
      {children}
    </div>
  );
};

export default IconWrapper;
